import * as angular from 'angular';
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";
import {AgentModel} from "./angular/models/agent.model";
import {BringozArray} from "../persistence-layer/bringoz-array";

angular
  .module('bringoz.admin.agents')
  .factory('$agents', AgentsArray);

export type $agentsFactory = () => BringozArray<AgentModel>;


/* @ngInject */
function AgentsArray($bringozFactory: $bringozFactory,
                     AgentsAPI: BringozApi,
                     Agents_DS: DataStoreConfig,
                     Agents_PN: PushNotificationsConfig) {
  function $agents() {
    return $bringozFactory<AgentModel>(null, AgentsAPI, Agents_DS, Agents_PN);
  }

  return $agents;
}

